import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { transformResults } from "~/pages/StcFinderPage/transformers";
import { type TypeSTCfinderFilterResults } from "~/pages/StcFinderPage/types";

function getOnlyNumbersFromZipCode(txt: string) {
  return (txt.match(/\d/g) ?? []).join("");
}

export async function getSTCfinderResults(
  country?: string,
  state?: string,
  zipCode?: string,
): Promise<TypeSTCfinderFilterResults> {
  const stateParam = state ? `&region=${state}` : "";
  const zipCodeParam = zipCode ? `&pincode=${getOnlyNumbersFromZipCode(zipCode)}` : "";
  const url = occUrl(`/stc/filter?country=${country ?? ""}${stateParam}${zipCodeParam}`);

  const response = await occFetch(url);

  if (!response.ok) {
    throw new Error("Error status: " + response.status + ", please try again");
  }
  const apiData = await response.json();

  return transformResults(apiData);
}
